import React, { useState, useRef, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useSearchParams } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useDispatch } from "react-redux";
import axios from "axios";
//
import { AuditTrailModal } from "modals/components/AuditTrailModal";
import { setInfo } from "redux/slices/basicInfoReducer";

const ViewFinalPdf = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  //
  const [numPages, setNumPages] = useState(0);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const [mobilePageWidth, setMobilePageWidth] = useState(
    Math.max(1, window.innerWidth - 32),
  );
  const [pdfLiveUrl, setPdfLiveUrl] = useState("");
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isAuditHistoryShown, setIsAuditHistoryShown] = useState(false);

  //
  const zoomContainerRef = useRef<any>(null);
  //
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const updateViewportWidth = () => {
      setDeviceWidth(window.innerWidth);
      setMobilePageWidth(Math.max(1, window.innerWidth - 32));
    };

    window.addEventListener("resize", updateViewportWidth);
    return () => window.removeEventListener("resize", updateViewportWidth);
  }, []);

  useEffect(() => {
    const uuid = searchParams.get("uuid");
    const uuidTemplateInstance = searchParams.get("uuid_template_instance");
    const uuidSignatory = searchParams.get("uuid_signatory");

    console.log(
      "===========================================================================",
    );
    const pdfUrl = `${process.env.REACT_APP_API_URL}/docSignRequestInstance/getPdfWithCoordinates?document_uuid=${uuid}&document_sign_request_uuid=${uuidTemplateInstance}`;
    setPdfLiveUrl(pdfUrl);
    console.log("pdf:", pdfUrl);
    dispatch(setInfo({ uuid, uuidTemplateInstance, uuidSignatory }));

    // Fetch PDF as blob with ngrok header
    const fetchPdf = async () => {
      try {
        const response = await axios.get(pdfUrl, {
          responseType: "blob",
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (error) {
        console.error("Failed to fetch PDF:", error);
      }
    };

    fetchPdf();

    return () => {
      if (pdfBlobUrl) {
        window.URL.revokeObjectURL(pdfBlobUrl);
      }
    };
  }, []);

  const zoomControl = (operation: string) => {
    switch (operation) {
      case "in":
        zoomContainerRef.current.zoomIn(0.1);
        break;
      case "out":
        zoomContainerRef.current.zoomOut();
        break;

      default:
        break;
    }
  };

  const handleDownloadPdf = () => {
    try {
      const a = document.createElement("a");
      a.href = `${pdfLiveUrl}&isDownload=true`;
      a.download = "document.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadPdfWithBlob = async () => {
    try {
      const response = await axios.get(pdfLiveUrl, {
        responseType: "blob",
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "Signed_Document.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.log(err);
    }
  };

  const toggleDropDown = () => setDropdownOpen((prevState) => !prevState);

  const handlePrintPdf = async () => {
    try {
      window.open(pdfLiveUrl, "_blank", "");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className="pdfviewer-header d-flex justify-content-between gap-3 py-2 text-light mb-2 p-2 align-items-center"
        style={{
          fontSize: "1rem",
          backgroundColor: "#354259",
          position: "sticky",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1,
        }}
      >
        <h4 className="text-light fw-bold">
          Erudite Docs<span className="mx-1"></span>
        </h4>

        <div className="d-flex gap-3">
          {deviceWidth >= 600 && (
            <>
              <span>
                <i
                  className="fa-solid fa-magnifying-glass-plus cursor-pointer"
                  onClick={() => zoomControl("in")}
                ></i>
              </span>
              <span>
                <i
                  className="fa-solid fa-magnifying-glass-minus cursor-pointer"
                  onClick={() => zoomControl("out")}
                ></i>
              </span>
            </>
          )}
          <span>
            <i
              className="fa-solid fa-download cursor-pointer"
              onClick={() => handleDownloadPdfWithBlob()}
            ></i>
          </span>
          <span>
            <i
              className="fa-solid fa-print cursor-pointer"
              onClick={() => handlePrintPdf()}
            ></i>
          </span>
        </div>
        <div>
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggleDropDown}
            direction={"down"}
          >
            <DropdownToggle
              caret
              style={{ backgroundColor: "#cdc2ae" }}
              color="black"
              className="fw-bold"
            >
              Options
            </DropdownToggle>
            <DropdownMenu style={{ minWidth: 150 }}>
              <DropdownItem
                onClick={() => {
                  setIsAuditHistoryShown(true);
                }}
              >
                View History
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div
        style={{
          height: "calc(100vh - 40px)", // adjust 60px to match your header height
          overflow: "auto",
          width: "100vw",
        }}
      >
        <div
          className="mt-3"
          style={{
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "center",
            padding: "0 16px 40px",
          }}
        >
          <TransformWrapper
            maxScale={3}
            initialScale={1}
            disablePadding
            wheel={{ disabled: true }}
            disabled={deviceWidth <= 600}
            ref={zoomContainerRef}
          >
            <TransformComponent>
              {pdfBlobUrl ? (
                <Document
                  file={pdfBlobUrl}
                  onLoadSuccess={({ numPages }) => {
                    setNumPages(numPages);
                  }}
                  renderMode="canvas"
                >
                  {[...Array(numPages)].map((_, index) => {
                    return (
                      <div key={index} className="m-0 p-0 mb-5 my-3">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <Page
                            pageNumber={index + 1}
                            width={
                              deviceWidth <= 600 ? mobilePageWidth : undefined
                            }
                            className="border animated-pdf-page"
                          />
                          <div
                            style={{ textAlign: "right" }}
                            className="fw-bold"
                          >
                            Page {index + 1} of {numPages}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Document>
              ) : (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  Loading PDF...
                </div>
              )}
            </TransformComponent>
          </TransformWrapper>
        </div>
      </div>
      {isAuditHistoryShown && (
        <AuditTrailModal setIsAuditHistoryShown={setIsAuditHistoryShown} />
      )}
    </>
  );
};

export default ViewFinalPdf;
